import { Link } from "react-router-dom";
import { Sparkles, Camera, ShoppingBag, ArrowUpRight } from "lucide-react";

const HIGHLIGHTS = [
  {
    icon: Sparkles,
    eyebrow: "01 - Live",
    title: "In-Person Sessions",
    text: "Private, face-to-face hypnosis in a discreet setting. Bespoke, paced, profoundly attended.",
    cta: "Book Live",
    href: "/book",
    testid: "hi-inperson",
  },
  {
    icon: Camera,
    eyebrow: "02 - Recorded",
    title: "Fly-on-the-Wall Videos",
    text: "Professionally filmed recordings of consenting in-person sessions. Private or, with release, public.",
    cta: "Request a Recording",
    href: "/services#fly-on-the-wall",
    testid: "hi-recording",
  },
  {
    icon: ShoppingBag,
    eyebrow: "03 - Library",
    title: "Media Store",
    text: "Guided MP3s, extended audio and selected recorded sessions - delivered via secure platforms.",
    cta: "Enter the Shop",
    href: "/shop",
    testid: "hi-shop",
  },
];

export default function ServiceHighlights() {
  return (
    <section className="py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-10 lg:px-16" data-testid="service-highlights">
      <div className="grid md:grid-cols-12 gap-10 md:gap-16 mb-16">
        <div className="md:col-span-5">
          <div className="eyebrow mb-3">The Offering</div>
          <h2 className="font-serif text-4xl md:text-5xl text-cream leading-tight">
            Three doorways into <em className="text-gold">trance</em>.
          </h2>
        </div>
        <div className="md:col-span-7 md:pt-6">
          <p className="text-cream/70 leading-relaxed">
            Each modality is held with the same intention: explicit consent, steady pacing,
            and a careful return. Recording is never assumed - only invited, only signed for,
            never shared without your written agreement.
          </p>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-px bg-[#c9a04b]/20">
        {HIGHLIGHTS.map(({ icon: Icon, ...h }, i) => (
          <Link
            key={h.testid}
            to={h.href}
            data-testid={h.testid}
            className="group relative bg-charcoal hover:bg-charcoalMuted transition-colors p-10 flex flex-col min-h-[420px]"
          >
            <Icon size={28} strokeWidth={1} className="text-gold mb-10" />
            <div className="eyebrow mb-3">{h.eyebrow}</div>
            <h3 className="font-serif text-3xl text-cream mb-4 leading-snug">{h.title}</h3>
            <p className="text-sm text-cream/65 leading-relaxed flex-1">{h.text}</p>
            <div className="mt-8 flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-gold">
              {h.cta}
              <ArrowUpRight size={14} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
            </div>
            <span className="absolute top-6 right-6 font-serif italic text-cream/10 text-5xl">{String(i + 1).padStart(2, "0")}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}
